import StyledInput from 'components/styledInput/StyledInput';

const ResponsibleSection = ({
  personInCharge,
  setPersonInCharge,
  personInChargeFunction,
  setPersonInChargeFunction,
  errorsPersonInCharge,
  errorsPersonInChargeFunction,
  setDataCreateMission,
  lastContactSuggestions = [],
  listEmployees = [],
}) => {
  const onNameChange = (value) => {
    setPersonInCharge(value);
    setDataCreateMission((prev) => ({
      ...prev,
      contact_name: value,
    }));
  };

  const onFunctionChange = (value) => {
    setPersonInChargeFunction(value);
    setDataCreateMission((prev) => ({
      ...prev,
      contact_poste: value,
    }));
  };

  const onClickContactSuggestion = (suggestion) => {
    onNameChange(suggestion.name);
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="text-xl">Responsable de la mission</div>
      <StyledInput
        label="Responsable"
        type="autocomplete"
        value={personInCharge}
        onChange={(e) => onNameChange(e.target.value)}
        list={listEmployees.map((emp) => ({
          label: emp.name,
          value: emp.name,
        }))}
        error={errorsPersonInCharge}
        listSuggestions={lastContactSuggestions}
        onClickSuggestion={onClickContactSuggestion}
      />
      <StyledInput
        label="Fonction"
        type="text"
        value={personInChargeFunction}
        onChange={(e) => onFunctionChange(e.target.value)}
        error={errorsPersonInChargeFunction}
      />
    </div>
  );
};

export default ResponsibleSection;
